export default "/assets/images/mila-opened-door-filter-boxes.png?8f90c3828f097cbc3af4126bf4ad8a20";